<template>

		<v-dialog v-model="dialog" persistent max-width="600px">
			<template v-slot:activator="{ on, attrs }">				
					<v-icon v-bind="attrs" small v-on="on">mdi-dots-vertical</v-icon>
			</template>
			<v-card>
				<v-card-title>
					<span class="headline">Create Material Alias</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form ref="form" v-model="valid">
							<v-row>
								<v-col cols="12">
									<v-text-field v-model="material.alias" label="Material Alias *" :counter="200" required></v-text-field>
								</v-col>
								<v-col cols="12">
									<span>Name:&nbsp;{{material.name}}</span>
									<!--<v-text-field v-model="material.name" label="Material Name" disabled></v-text-field>-->
								</v-col>
								<v-col cols="12">
									<span>Description:&nbsp;{{material.description}}</span>
									<!--<v-text-field v-model="material.description" label="Description" disabled></v-text-field>-->
								</v-col>
							</v-row>
						</v-form>
					</v-container>
					<small>* indicates required field</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialog = false; reset();">Close</v-btn>
					<v-btn color="blue darken-1" text @click="saveMaterial();" :disabled="!valid" :loading="submitting">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import appsettings from '../../appsettings.js';
  import axios from "axios";
	export default {
		data: () => ({
			dialog: false,
			material: {
				id: null,
				name: "",
				description: "",
				alias: "",
				materialAliasId: null,
				isAdHoc: false,
				isActive: true
			},
			rules: {},
			originalAlias: {},
			valid: false,
			submitting: false,
			notification: 0,
			locationId: null,
			locationDepartmentId: null
		}),
        props: {
            item: {}
        },
		mounted() {
			this.locationId = this.$route.params.locationId;
			this.locationDepartmentId = this.$route.params.locationDepartmentId;
            
			this.material = this.item;
			this.originalAlias = Object.assign(this.originalAlias, this.material); 

			this.material.locationId = this.locationId;
            this.material.locationDepartmentId = this.locationDepartmentId;

			
        },
		methods: {
			...mapActions(["sendMessage"]),
			async saveMaterial() {
				if (this.valid)	{

					this.item.alias = this.material.alias;

					try {
            let response = await axios.put(`/api/Material/materialalias`, this.material)
            let data = response.data;
            //Must use Object.assign to transfer updated values
            //to the underlying reactive object and maintain reactive props.

            this.item.materialAliasId = data.materialAliasId;

            //Unfortunately this form maintains state between calls
            this.originalAlias.materialAliasId = this.item.materialAliasId;
            this.originalAlias.alias = this.item.alias;

            this.submitting = false;
            this.dialog = false;
            this.sendMessage({
              color: "success",
              text: "Material Alias successfuly updated.",
              timeout: 6000
            });

            this.clear();
          }
          catch(error) {
            this.item.alias = this.originalAlias.alias;
            this.item.materialAliasId = this.originalAlias.materialAliasId;
            this.submitting = false;
            this.dialog = false;
            this.sendMessage({
              color: "error",
              text: "Failed to update Material Alias!",
              timeout: 6000
            });
          }
				}
			},
			clear() {

			},
			reset() {

				this.material.alias = this.originalAlias.alias;

				this.$refs.form.resetValidation(); 
			}
		},
		computed: {
            ...mapGetters(['getVrsUser'])
		}
	}
</script>